export default __webpack_public_path__ + "static/media/navigation-menu-horizontal.a4b54eea.svg";